import { render, staticRenderFns } from "./Cameras.vue?vue&type=template&id=65a4734c&scoped=true"
import script from "./Cameras.vue?vue&type=script&lang=ts"
export * from "./Cameras.vue?vue&type=script&lang=ts"
import style0 from "./Cameras.vue?vue&type=style&index=0&id=65a4734c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a4734c",
  null
  
)

export default component.exports